import React, { useState, useEffect } from 'react';
import { getUserRating } from '../../api/api';

export const getEnergyMeterClass = (em, activityId) => {
  if (!em || !em.active || em.mode !== 'analysis') return '';
  const stats = em.stats?.activities?.[activityId];
  if (!stats || !stats.threshold_passed) return '';

  if (stats.is_hotspot) return 'em-tint-hotspot';
  if (stats.dominant === 'e') return 'em-tint-e';
  if (stats.dominant === 'd') return 'em-tint-d';
  if (stats.dominant === 'mixed') return 'em-tint-mixed';
  return '';
};

const ActivityEnergyLayer = ({ data, activityId, activityTitle }) => {
  const em = data?.em;
  const [myVote, setMyVote] = useState(null);

  useEffect(() => {
    let isMounted = true;
    if (em && em.active && em.mode === 'input' && em.processId && activityId) {
      getUserRating(em.processId, activityId, em.version).then((res) => {
        if (isMounted && res && res.rated) {
          setMyVote(res.vote);
        } else if (isMounted) {
          setMyVote(null);
        }
      });
    }
    return () => {
      isMounted = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [em?.active, em?.mode, em?.processId, em?.version, em?.lastUpdated, activityId]);

  if (!em || !em.active) return null;

  const { mode, stats, promptActivity, onOpenPrompt } = em;
  const activityStats = stats?.activities
    ? stats.activities[activityId] ||
      stats.activities[String(activityId)] ||
      stats.activities[Number(activityId)]
    : undefined;
  const isPromptOpen = promptActivity && String(promptActivity.id) === String(activityId);

  if (mode === 'input') {
    let voteClass = '';
    let iconClass = 'fa-battery-half';
    if (myVote === 'e') {
      voteClass = 'em-handle--rated-e';
      iconClass = 'fa-battery-full';
    } else if (myVote === 'n') {
      voteClass = 'em-handle--rated-n';
      iconClass = 'fa-battery-half';
    } else if (myVote === 'd') {
      voteClass = 'em-handle--rated-d';
      iconClass = 'fa-battery-quarter';
    }

    return (
      <div
        className="activity__handle-slot"
        style={{
          position: 'absolute',
          top: '4px',
          right: '4px',
          zIndex: 10,
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          className={`em-handle ${isPromptOpen ? 'em-handle--open' : ''} ${voteClass}`}
          type="button"
          aria-label="Rate this step"
          onClick={(e) => {
            e.stopPropagation();
            onOpenPrompt({ id: activityId, title: activityTitle });
          }}
        >
          <i className={`fas ${iconClass}`}></i>
        </button>
      </div>
    );
  }

  if (mode === 'analysis') {
    if (activityStats && !activityStats.threshold_passed) {
      const minRatings = stats?.min_ratings ?? 5;
      return (
        <div
          style={{
            position: 'absolute',
            top: '4px',
            right: '4px',
            zIndex: 10,
            cursor: 'default',
          }}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <span
            className="em-pending"
            title={`Awaiting more ratings (${activityStats.total}/${minRatings})`}
          >
            <i className="fas fa-hourglass-half"></i> {activityStats.total}/{minRatings}
          </span>
        </div>
      );
    }
  }

  return null;
};

export default ActivityEnergyLayer;
